import { VolumeUnit } from '@grc/ui-shared';
import { Shape } from '@grc/ui-shared/lib/components/models/enums/enums';
import I18N from '../../i18n/interface';
import { LoadRestrictions, Orientation } from '../../enums/create-order-enum';
import { InvoiceTabKey } from '../../models/invoices/invoice.interface';
import dayjs from 'dayjs';

export const headerPopoverWidth = '300px';

export const tenantService = 'tenant';

export const trackingService = 'tracking';

export const shipmentService = 'shipment';

export const documentService = 'document';

export const orderService = 'order';

export const productService = 'product';

export const ratingService = 'contract';

export const commentService = 'comments';

export const exceptionService = 'exception';

export const transportationService = 'transport';
export const quoteService = 'quote';
export const invoiceService = 'invoicing';
export const logisticPlanService = 'logisticPlan';

export const portalAccountId = '42c0e604-9b3e-44d9-b029-77e0a77180e9';

// Hardcoded until the Home/Shipments APIs can resolve the logged-in user's account dynamically.
export const homeShipmentsAccountId = '8ae34d04-c0d4-47b1-938c-2e991b35eb5e';

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const defaultPhoneCountry = 'United States';
export const emptyPhoneNumber = '';
export const maskRules = { X: /[02-9]/ };

export const volumeUnits = [
  { id: VolumeUnit.CubicFeet, text: 'Cubic Feet' },
  { id: VolumeUnit.CubicInches, text: 'Cubic Inches' },
  { id: VolumeUnit.CubicMeter, text: 'Cubic Meter' }
];

export const loadRestrictions = [
  {
    id: LoadRestrictions.NoTopLoadUnevenLayer,
    value: 'No top load - Uneven Layer'
  },
  {
    id: LoadRestrictions.NoTopLoadLabeledInstruction,
    value: 'No top load - Labeled Instruction'
  },
  {
    id: LoadRestrictions.LightTopLoadTooHeavy,
    value: 'Light top load - Too Heavy'
  },
  {
    id: LoadRestrictions.LightTopLoadInadequetePackaging,
    value: 'Light top load - Inadequete Packaging'
  },
  { id: LoadRestrictions.NoRestriction, value: 'No Restriction' }
];

export const handlingUnitShape = [
  {
    id: Shape.Cubic,
    text: 'Cubic'
  },
  {
    id: Shape.Cylindrical,
    text: 'Cylinder'
  }
];

export const orientationDataSource = [
  { id: Orientation.AsDefined, value: 'As Defined' },
  { id: Orientation.Turned, value: 'Or Turned' }
];

export const toDate = (
  value: string | number | Date | undefined
): Date | undefined => {
  if (!value) return undefined;
  const d = new Date(value);
  return isNaN(d.getTime()) ? undefined : d;
};

export const normalize = (value: string | number | Date | undefined) => {
  const d = toDate(value);
  return d ? dayjs(d).startOf('minute') : undefined;
};

export const isBeforeOrSame = (
  a: string | number | Date | undefined,
  b: string | number | Date | undefined
) => {
  const d1 = normalize(a);
  const d2 = normalize(b);
  if (!d1 || !d2) return false;
  return d1.isBefore(d2) || d1.isSame(d2);
};

export const isAfterOrSame = (
  a: string | number | Date | undefined,
  b: string | number | Date | undefined
) => {
  const d1 = normalize(a);
  const d2 = normalize(b);
  if (!d1 || !d2) return false;
  return d1.isAfter(d2) || d1.isSame(d2);
};

export const isInvalidYear = (date: Date) =>
  date.getFullYear().toString().length > 4;

export const maxFileSize = 10 * 1024 * 1024; // 10MB
export const allowedFileTypes = ['.png', '.jpg', '.jpeg'];

export const invoiceTabs: { key: InvoiceTabKey; labelKey: keyof I18N }[] = [
  { key: 'invoicedShipments', labelKey: 'InvoicedShipments' },
  { key: 'notInvoiced', labelKey: 'ShipmentsAreNotInvoiced' },
  { key: 'disputed', labelKey: 'DisputedInvoices' }
];
